import { BusinessTarget, Locale } from '@shopee-user/global';
import { ROUTES } from '@shopee-user/url';
import { Feature } from '@shopee-user/feature-toggle';

export enum AccountType {
  PureToB = 'pure-tob',
  PureToC = 'pure-toc',
  ToBOneCredential = 'tob-one-credential',
}

const getToBSandboxConfigKey = (accountType: AccountType) =>
  `@tob/sandbox-app-config-${accountType}`;

export function isUsingSandboxEnvironment() {
  if (__BUSINESS_TARGET__ === BusinessTarget.Sandbox) {
    return true;
  }
  return false;
}

const getAccountType = () => {
  switch (__LOCALE__) {
    case Locale.SG:
      return AccountType.PureToB;
    case Locale.ID:
      return AccountType.PureToC;
    case Locale.TH:
      return AccountType.ToBOneCredential;
    default:
      return undefined;
  }
};

export function getSandboxConfigFromSessionStorage(): Partial<
  Record<Feature, boolean> | undefined
> {
  const accountType = getAccountType();
  if (isUsingSandboxEnvironment() && !!accountType) {
    try {
      const config = JSON.parse(
        sessionStorage.getItem(getToBSandboxConfigKey(accountType)) || ''
      );
      return config;
    } catch (e) {
      return undefined;
    }
  }
  return undefined;
}

export function saveSandboxConfigFromSessionStorage(
  config: Partial<Record<Feature, boolean>>
) {
  const accountType = getAccountType();
  if (isUsingSandboxEnvironment() && !!accountType) {
    sessionStorage.setItem(
      getToBSandboxConfigKey(accountType),
      JSON.stringify(config)
    );
  }
}

export function isInSandboxConfigPage() {
  return window.location.pathname.includes(ROUTES.CONFIG);
}
